// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CapsuleButton } = require('client-v2/common/components/buttons')

const bem = BemEntity('ErrorPage')

function ErrorPage(props) {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('header', {
        className: bem.element('header')
      },
        tag('div', {
          className: bem.element('splash')
        }),
        tag('a', {
          href: '/',
          className: bem.element('logo')
        })
      ),
      tag('h1', {
        className: bem.element('heading')
      },
        'Oops!'
      ),
      tag('h2', {
        className: bem.element('subheading')
      },
        'Something went wrong. Please reload and try again.'
      ),
      tag('h3', {
        className: bem.element('call-to-action')
      },
        'If you are still having issues, ',
        tag('a', {
          className: bem.element('href'),
          href: 'mailto:support@mix.com',
          onClick: event => {
            if (typeof window.Intercom === 'function') {
              event.preventDefault()
              window.Intercom('show')
            }
          }
        },
          'contact our support team'
        ),
        '.\n',
        'We have humans here to help.'
      ),
      tag('div', {
        className: bem.element('buttons')
      },
        tag(CapsuleButton, {
          className: bem.element('button', 'reload'),
          onClick: () => {
            window.location.reload()
          }
        },
          'Reload'
        ),
        props.onDismiss && tag(CapsuleButton, {
          className: bem.element('button', 'dismiss'),
          onClick: props.onDismiss
        },
          'Dismiss'
        )
      ),
      props.children
    )
  )
}

ErrorPage.propTypes = {
  children: PropTypes.node,
  onDismiss: PropTypes.func.isRequired
}

module.exports = ErrorPage
